import { Component, Output, EventEmitter, ViewChildren, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MediaService } from '../shared-services/media.service';

export interface ISelectedChip {
  chipKey: string;
  chipLabel: string;
  categoryName: string;
  typeId: any;
  selectedChipFilterComponent: any;
}

export interface NotificacionFiltersChange {
  chips: ISelectedChip[];
}


@Component({
  selector: 'app-notificacion-filter',
  styleUrls: ['./notificacion-filter.component.scss'],
  templateUrl: './notificacion-filter.component.html',
})
export class NotificacionFilterComponent implements OnInit, OnChanges {
  isMobile: boolean;

  @Output() filtersChanged = new EventEmitter<NotificacionFiltersChange>();
  @Output() onChipRemove = new EventEmitter<ISelectedChip[]>();
  @Output() onHide = new EventEmitter<void>();

  selectedChips: ISelectedChip[] = [];
  selectedHasDataFilters: number[];
  showDateAfterFilter: boolean;
  showDateBeforeFilter: boolean;

  constructor(
    private mediaService: MediaService,
  ) {}

  ngOnInit() {
    this.mediaService.isMobile.subscribe(isMobile => this.isMobile = isMobile);
  }

  ngOnChanges(changes: SimpleChanges) {}

  onRemoveChip(selectedChip: ISelectedChip) {
    this.selectedChips = this.selectedChips.filter(x => x.chipKey !== selectedChip.chipKey);
    this.onChipRemove.emit(this.selectedChips);
  }

  onTogglePickerFrom(event: any) {
    event.stopPropagation();
  }

  onTogglePickerTo(event: any) {
    event.stopPropagation();
  }
}



// WEBPACK FOOTER //
// ./src/app/notificacion/notificacion-filter.component.ts